// @ts-ignore
import flatten from 'flat';
import enMessages from './translations/en.json';
import koMessages from './translations/ko.json';
import zhMessages from './translations/zh-CN.json';

const messages: {
  [key: string]: {},
} = {
  'en': flatten(enMessages),
  'zh-CN': flatten(zhMessages),
  'ko': flatten(koMessages),
};

export default messages;
